import React, { useEffect, useState } from "react";
import configData from "../config.json";
import "./WifiInput.css";
import WifiDataDialog from "../components/multi_components/WifiDataDialog";
import { CircularProgress } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getToken } from "../utils/auth"

function WifiReport() {
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const [potatoes, setPotatoes] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  //Input management
  const [wifiList, setWifiList] = useState(["TivTaam_Online"]);
  const [minimized, setMinimized] = useState(false);
  const [wifiTableData, setWifiTableData] = useState(null);
  const [wifiLoading, setWifiLoading] = useState(false);

  const handleAddWifi = () => {
    setWifiList((prevState) => [...prevState, ""]);
  };

  const handleRemoveWifi = (index) => {
    setWifiList((prevState) => {
      const updatedWifiList = [...prevState];
      updatedWifiList.splice(index, 1);
      return updatedWifiList;
    });
  };

  const handleWifiChange = (event, index) => {
    const newWifiList = [...wifiList];
    newWifiList[index] = event.target.value;
    console.log(event.target.value);
    if (event.target.value === "potatoes") {
      console.log("true");
      setPotatoes(true);
    }
    setWifiList(newWifiList);
  };

  //selected tablets data fetch
  const [devices, setDevices] = useState(null);
  useEffect(() => {
    const token = getToken()
    let serial_string = atob(params.serials);
    let serial_list = JSON.parse(serial_string);
    let newBody = {
      serial_numbers: serial_list,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/RT/wifi-report`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setDevices(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          notify(error, "error");
        }
      });
  }, []);
  const getWifiReportResults = () => {
    setWifiLoading(true);
    const token = getToken()
    let newBody = {
      query_list: wifiList,
      selected_devices: devices,
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/RT/wifi-report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setWifiTableData(data);
        setWifiLoading(false);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          notify(error, "error");
        }
      });
  };
  const triggerWifiDataLogs = () => {
    let serial_numbers = devices.map((item) => item.serial_number);
    const token = getToken()
    let swanbody = {
      tablets: serial_numbers,
      message: "Trigger search wifi networks",
      retailer: params.retailer,
      store: params.store,
    };
    fetch(`${configData.SERVER_URL}/Trigger/SwanSong`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(swanbody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  return (
    <div className="container">
      <div className="top-left-buttons">
        <button className="btn btn-primary" onClick={getWifiReportResults}>
          Reload Data
        </button>
        <button className="btn btn-primary" onClick={triggerWifiDataLogs}>
          Trigger WiFi Log
        </button>
      </div>
      <div className="wifi-input-container">
        {minimized ? (
          <div className="minimized-icon" onClick={() => setMinimized(false)}>
            <i className="fas fa-wifi">
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "24px", marginTop: "1vh" }}
              >
                edit
              </span>
            </i>
          </div>
        ) : (
          <>
            <h2 style={{ marginTop: "3vh" }}>WiFi Settings</h2>
            <div className="wifi-input-form">
              <div className="secondary-wifi-inputs">
                {wifiList.map((wifi, index) => (
                  <div key={index} className="form-group">
                    <label htmlFor={`wifi-input-${index}`}>
                      {index === 0 ? "Primary WiFi" : `Secondary WiFi ${index}`}
                    </label>
                    <div className="input-group-wifi">
                      <input
                        id={`wifi-input-${index}`}
                        type="text"
                        className="form-control"
                        value={wifi}
                        onChange={(event) => handleWifiChange(event, index)}
                      />
                      {index > 0 && (
                        <button
                          className="btn btn-danger"
                          onClick={() => handleRemoveWifi(index)}
                        >
                          -
                        </button>
                      )}
                    </div>
                  </div>
                ))}

                <button className="btn btn-secondary" onClick={handleAddWifi}>
                  Add Secondary WiFi
                </button>
                <button
                  className="btn btn-submit"
                  onClick={() => {
                    setMinimized(!minimized);
                    getWifiReportResults();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      {/* Table of wifi report */}
      {wifiTableData && wifiLoading === false ? (
        <div className="container">
          <div className="row">
            {wifiList.map((wifi, index) => (
              <div className="col-xs-12 col-sm-3" key={index}>
                <div>
                  <h5 className="mb-1 table" style={{ textAlign: "center" }}>
                    {wifi}
                  </h5>
                  <hr className="separator" />
                </div>
                <div className="list-group">
                  {wifiTableData.map(
                    (item, index) =>
                      item.matched === wifi && (
                        <span key={index}>
                          <WifiDataDialog item={item} />
                        </span>
                      )
                  )}
                </div>
              </div>
            ))}
            <div className="col-xs-12 col-sm-3">
              <div>
                {" "}
                <h5 className="mb-1 table" style={{ textAlign: "center" }}>
                  Other
                </h5>
                <hr className="separator" />
              </div>
              {wifiTableData.map((item, index) => (
                <>
                  {item.matched === "Other" && (
                    <WifiDataDialog item={item} key={index} />
                  )}
                </>
              ))}
            </div>
            <div className="col-xs-12 col-sm-3">
              <div>
                {" "}
                <h5 className="mb-1 table" style={{ textAlign: "center" }}>
                  N/A
                </h5>
                <hr className="separator" />
              </div>

              {wifiTableData.map((item, index) => (
                <>
                  {item.matched === "N/A" && (
                    <WifiDataDialog item={item} key={index} />
                  )}
                </>
              ))}
            </div>
          </div>
        </div>
      ) : wifiLoading === true && potatoes === true ? (
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              height: "100vh",
            }}
          >
            <iframe
              src="https://giphy.com/embed/dXZfUpbhoEqjWfNq1v"
              style={{ height: "100vh" }}
              frameBorder="0"
              class="giphy-embed"
              allowFullScreen
            ></iframe>
          </div>
          <p>
            <a href="https://giphy.com/gifs/fart-potato-potatoes-dXZfUpbhoEqjWfNq1v">
              via GIPHY
            </a>
          </p>
        </div>
      ) : (
        wifiLoading === true &&
        potatoes === false && (
          <div style={{ textAlign: "center" }}>
            <CircularProgress size={72} />{" "}
          </div>
        )
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default WifiReport;
